export default __webpack_public_path__ + "static/media/russian poker-04.89bb69c5.png";